import { DATE_RANGES } from './types'
import type { DateRange } from './types'

const MS_PER_HOUR = 60 * 60 * 1000
const MS_PER_DAY = 24 * MS_PER_HOUR

export type PublishedAtRange = {
  dateStart?: string
}

/**
 * Resolves a relative date-range filter into a concrete ISO start timestamp for
 * query variables.
 *
 * The anchor is rounded up to the next hour so every consumer resolving the
 * same range within the same hour produces identical strings. Query variables
 * therefore stay byte-identical across components and remounts, sharing one
 * Apollo cache entry instead of fragmenting it with per-render timestamps.
 *
 * The range is open ended on purpose. An end bound resolves once, and a page
 * that stays open then holds a bound in the past: every item published after it
 * drops out of the list, and only a reload brings it back.
 */
export const getPublishedAtRange = (
  publishedAt: DateRange | undefined,
): PublishedAtRange => {
  if (!publishedAt) return {}
  const days = DATE_RANGES[publishedAt]
  if (!days) return {}
  const anchor = Math.ceil(Date.now() / MS_PER_HOUR) * MS_PER_HOUR
  return {
    dateStart: new Date(anchor - days * MS_PER_DAY).toISOString(),
  }
}
